module.exports = __webpack_public_path__ + "static/img/sangdi5.65461517.jpg";